export default __webpack_public_path__ + "static/getting01-cd06c485a56cc87354215827387eaae7.png";